import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import * as cartSlice from "../store/cart"
import * as dealApis from "../utilities/apis/deal"

const HomeDeals = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const cartState = useSelector((state) => state.cart)
  const [deals, setDeals] = useState([])

  const handleView = (slug) => {
    navigate(`/deals/${slug}`)
  }

  const handleCart = async (e, deal) => {
    e.stopPropagation()
    dispatch(cartSlice.addToCart(deal))
  }

  const handleDecrement = async (e, slug) => {
    e.stopPropagation()
    dispatch(cartSlice.handleDecrement(slug))
  }

  const handleIncrement = async (e, slug) => {
    e.stopPropagation()
    if (cartState.productsById[slug] >= 5) return alert('For more than 5 quantity please contact our support on whatsapp')
    dispatch(cartSlice.handleIncrement(slug))
  }

  const getDeals = async () => {
    try {
      const response = await dealApis.getHomeDeals()
      if (!response.status) throw new Error(response.message)

      setDeals(response.deals)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getDeals()
  }, [])

  if (!deals.length) return null

  return (
    <section id="deals" className="py-3 py-sm-4 py-lg-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-3 mb-sm-4 mb-lg-5">
          <h1 className="text-body-emphasis fw-bold m-0">Deals</h1>
          <Link to="/deals">Explore All Deals</Link>
        </div>

        <div className="row g-3 g-xl-2">
          {deals.map((deal) => {
            let src = "/upload.png"
            if (deal.thumbnail) src = deal.thumbnail
            // if (deal.thumbnail_url) src = deal.thumbnail_url

            return (
              <div key={deal.id.toString()} className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                <div onClick={() => handleView(deal.slug)} className="card shadow-none text-dark p-1">
                  <img src={src} className="card-img-top img-fluid deal-image" alt={deal.title} />
                  <div className="card-body p-1 d-flex flex-column gap-2">
                    <div>
                      <p className="fw-bold m-0 text-truncate">{deal.title}</p>
                      <p className="card-text small text-muted m-0">{deal.products.length} products</p>
                    </div>
                    <p className="text-theme fw-bold m-0">Rs. {(deal.price - deal.discount).toFixed(2)}</p>
                    {
                      !cartState.productsById[deal.slug]
                        ? <button className="btn btn-sm btn-light-theme w-100" onClick={(e) => handleCart(e, deal)}>Add to Cart</button>
                        : <div className="d-flex gap-3 justify-content-between align-items-center">
                          <button type="button" className="btn btn-sm btn-light-theme flex-grow-1" onClick={(e) => handleDecrement(e, deal.slug)}><i className="bi bi-dash-lg"></i></button>
                          <p className="flex-grow-1 fs-5 text-muted text-center fw-bold m-0">{cartState.productsById[deal.slug]}</p>
                          <button type="button" className="btn btn-sm btn-light-theme flex-grow-1" onClick={(e) => handleIncrement(e, deal.slug)}><i className="bi bi-plus-lg"></i></button>
                        </div>
                    }
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeDeals